module.exports = __webpack_public_path__ + "Projects.a3e8cad548e8ab14985aadf73539f511.hashedasset.svg";